import { render, type ComponentChildren } from "preact";
import { useEffect } from "preact/hooks";

import { useVideoAd } from "../presentation/VideoAdContext";
import Loader from "./Loader";

export const CTAScreen = ({ children }: { children: ComponentChildren }) => {
  const { session, state } = useVideoAd();
  const { config } = state;
  const {
    containerClass,
    buttonClass,
    messageBoxClass,
    buttonTextClass,
    colLeftClass,
    colRightClass,
    messageText,
    buttonText,
    customTagline,
  } = config.CTAScreenConfig || {};

  const videoIsLoading = state.phase === "loading" || state.phase === "cta";
  const display = videoIsLoading ? 'flex' : 'none';
  const isLoaded = state.playerLoaded && state.bids !== null;

  useEffect(() => {
    if (isLoaded && config.autoplay && state.phase === "cta") {
      void session.startVideo();
    }
  }, [config.autoplay, isLoaded, session, state.phase]);

  const onClick = () => {
    if (isLoaded) void session.startVideo();
  };
  const __html = customTagline || '';

  const content = (
    <>
      <div className={`ark-cta-col-left ${colLeftClass || ""}`}></div>
      <div className={`ark-cta-col-right ${colRightClass || ""}`}>
        <div className={`ark-ad-message ${messageBoxClass || ""}`}>
          {messageText || "your game will begin after the following advertisement"}
        </div>
        <div className="ark-cta-buttons">
          <Loader />
          <button className={`ark-cta-play-button ark-ad-button ${buttonClass || ""}`} data-type="button" type="button">
            <div className={`ark-ad-button-text ${buttonTextClass || ""}`}>
              { buttonText || "Play"}
            </div>
          </button>
        </div>
      </div>
    </>
  );

  const appendCTA = (container: HTMLDivElement | null) => {
    if (!container) return;
    if (container.querySelector('.ark-cta-col-left')) {
      return container.insertAdjacentHTML('beforeend', '<div class="observer-trigger"></div>');
    };
    const fragment = document.createDocumentFragment();
    render(content, fragment);
    (container.children[0] || container).appendChild(fragment);
  };

  const ctaLoadingClass = isLoaded ? 'ark-cta-loaded' : 'ark-cta-loading';

  return (
    <>
      {children}
      <div dangerouslySetInnerHTML={{__html}} ref={appendCTA} onClick={onClick} className={`ark-cta ${ctaLoadingClass} ${containerClass || ""}`} style={{display}}>
      </div>
    </>
  );
};

export default CTAScreen;
